import { useRequest } from 'features/request/useRequest';
import type { ChapterEnum, PriceListUerRowDataFilterInput } from 'gql/graphql';
import { useAgGridDataSource } from 'hooks/useAgGridDataSource';

import { useEffect, useMemo, useState } from 'react';

import { getWorkOrderChangeUerPriceList } from '../../WorkOrderChangeQueries';

interface IUseUerWorkOrderChangePriceList {
    workOrderChangeObjectId?: number;
    workOrderChangeId: number;
    workOrderObjectId?: number;
    chapter: ChapterEnum;
    filterValues?: Record<string, string[]>;
    where?: PriceListUerRowDataFilterInput;
}

const requestId = 'workOrderChangeUerPriceList';

export const useUerWorkOrderChangePriceListData = (props: IUseUerWorkOrderChangePriceList) => {
    const { workOrderChangeObjectId, chapter, where, workOrderChangeId, workOrderObjectId } = props;

    const [allIds, setAllIds] = useState<number[]>([]);

    const variables = useMemo(
        () => ({
            workOrderChangeId,
            workOrderChangeObjectId,
            workOrderObjectId,
            chapter,
            where,
        }),

        [chapter, where, workOrderChangeId, workOrderChangeObjectId, workOrderObjectId],
    );

    const [uerWorkOrderChangePriceListData, , , uerWorkOrderChangePriceListMakeRequest] = useRequest({
        requestId,
        query: getWorkOrderChangeUerPriceList,
        withEffect: false,
    });

    const { dataSource, getRowParams } = useAgGridDataSource({
        requestId,
        requestFn: uerWorkOrderChangePriceListMakeRequest,
        requestVariables: variables,
    });

    useEffect(() => {
        if (uerWorkOrderChangePriceListData?.uerWorkOrderChangePriceListUerQuery?.items && getRowParams?.current) {
            const items = uerWorkOrderChangePriceListData?.uerWorkOrderChangePriceListUerQuery?.items;

            getRowParams?.current?.successCallback(
                items,
                uerWorkOrderChangePriceListData?.uerWorkOrderChangePriceListUerQuery?.totalCount,
            );

            setAllIds((prevState) => [...prevState, ...items.map((item) => item.id)]);
        }
    }, [getRowParams, uerWorkOrderChangePriceListData?.uerWorkOrderChangePriceListUerQuery]);

    return {
        uerWorkOrderChangePriceListDataSource: dataSource,
        allIds,
    };
};
